import { render, staticRenderFns } from "./createUserGroup.vue?vue&type=template&id=2802057c&scoped=true&"
import script from "./createUserGroup.vue?vue&type=script&lang=js&"
export * from "./createUserGroup.vue?vue&type=script&lang=js&"
import style0 from "./createUserGroup.vue?vue&type=style&index=0&id=2802057c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2802057c",
  null
  
)

export default component.exports